/**
 * Vantage Core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PaymentSummaryViewModel } from './paymentSummaryViewModel';

export interface ProcedureTransactionSummaryViewModel {
  id?: string;
  visitId?: string;
  procedureCode?: string | null;
  procedureDescription?: string | null;
  modifier1Code?: string | null;
  modifier2Code?: string | null;
  modifier3Code?: string | null;
  modifier4Code?: string | null;
  fromDate?: string | null;
  ndcCode?: string | null;
  ndcQuantity?: number | null;
  ndcUnit?: string | null;
  attendingProviderId?: string | null;
  attendingProviderFirstName?: string | null;
  attendingProviderLastName?: string | null;
  attendingProviderTitle?: string | null;
  attendingProviderNpi?: string | null;
  attendingProviderProviderNumber?: string | null;
  locationId?: string | null;
  locationName?: string | null;
  locationCode?: string | null;
  placeOfServiceCode?: string | null;
  placeOfServiceName?: string | null;
  postDate?: string | null;
  procedureAmount?: number;
  balance?: number;
  adjusted?: number;
  paid?: number;
  insuranceBalance?: number;
  patientBalance?: number;
  diagnosisCode?: string | null;
  diagnosisDescription?: string | null;
  isReversed?: boolean;
  payments?: Array<PaymentSummaryViewModel> | null;
}
